import { render } from "./tabnav.vue?vue&type=template&id=76cfb43e&scoped=true"
import script from "./tabnav.vue?vue&type=script&lang=js"
export * from "./tabnav.vue?vue&type=script&lang=js"

import "./tabnav.vue?vue&type=style&index=0&id=76cfb43e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\admin-tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76cfb43e"]])

export default __exports__